"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
exports.useStyles = makeStyles_1.default(() => ({
    title: {
        cursor: 'move',
    },
    titleHeader: {
        fontWeight: 700,
        marginTop: 'auto',
        marginBottom: 'auto',
    },
    actions: {
        padding: '10px 24px',
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
    },
    buttonLabel: {
        textTransform: 'uppercase',
    },
}));
//# sourceMappingURL=dialog-styles.js.map